/* eslint quotes: 0 */
export default {
  "container": {
    "containerSearchInProgress": "Container search in progress",
    "noContainersWithSufficientProductQuantityFound": "No containers with sufficient quantities of the selected product were found.",
    "searchForProductInContainers": "Search product in containers"
  },
  "contractor": {
    "acceptanceDate": "Acceptance date",
    "all": "All",
    "chooseContractor": "Select contractor",
    "chooseEndedStatus": "Show only completed?",
    "chooseSettlementStatus": "Select settlement status",
    "contractor": "Contractor",
    "dateOfSampleAndAcceptance": "Test and approval date",
    "listOfContractorsWorksToBeSettled": "List of contractor's works to be settled",
    "makeSettlementErrorText": "Settlement failed. Please try again.",
    "noItemsToBeSettled": "No items for settlement",
    "onlyEnded": "Only completed",
    "serviceCost": "Cost of decoration",
    "toBeSettled": "To be settled",
    "unitPrice": "Unit price"
  },
  "contractorsSettlementsImportPopup": {
    "importSuccessDesc": "XLSX file data imported",
    "importSuccessTitle": "Imported data",
    "importTitle": "Import contractor's work list for settlement",
    "importXlsx": "Import XLSX file",
    "xlsxFile": "XLSX file"
  },
  "customer": {
    "addAddress": "Add address",
    "addAddressErrorText": "Adding an address has failed. Please try again.",
    "addAddressSuccessText": "The specified address has been saved",
    "addAddressSuccessTitle": "Address has been added",
    "addContactPerson": "Add contact person",
    "addContactPersonErrorText": "Adding a contact person failed. Please try again.",
    "addContactPersonSuccessText": "Contact person entered has been saved",
    "addContactPersonSuccessTitle": "Contact person has been added",
    "addCustomer": "Add customer",
    "addCustomerErrorText": "Adding a customer has failed. Please try again.",
    "addCustomerSuccessText": "The specified customer has been saved",
    "addCustomerSuccessTitle": "Customer has been added",
    "addErrorText": "An error occurred during customer creation",
    "addNewCustomer": "Add new customer",
    "addSuccessText": "Customer has been created from given data",
    "addSuccessTitle": "Customer added",
    "addingContactPersonAvailableAfterCustomerSave": "You will be able to add contact persons after saving the customer.",
    "addingNewCustomer": "Add new customer",
    "addingShippingAddressAvailableAfterCustomerSave": "Adding mailing addresses will be possible after the customer has been saved.",
    "addingTransaltionsAvailableAfterCustomerSave": "Adding translations will be possible once the customer has been saved.",
    "building": "Building",
    "buildingNumber": "Building number",
    "changePassword": "Change password",
    "changeYourPassword": "Change your password",
    "city": "City",
    "company": "Company",
    "companyName": "Company name",
    "contact": {
      "contact": "Contact"
    },
    "contactAddress": "Contact address",
    "contactPeople": "Contact persons",
    "correspondenceAddressSet": "Data changed",
    "correspondenceAddressSetDesc": "Correspondence address has been set",
    "correspondenceInfo": "Correspondence details",
    "customerCountryQuestionMark": "Customer country?",
    "customerLogo": "Customer logo",
    "customers": "Customers",
    "customersList": "List of customers",
    "deleteAddressConfirmTitle": "Are you sure you want to delete this address?",
    "deleteAddressErrorText": "Address deletion has failed. Please try again.",
    "deleteAddressSuccessText": "The selected address has been deleted",
    "deleteAddressSuccessTitle": "Address has been deleted",
    "deleteContactPersonConfirmTitle": "Are you sure you want to delete this contact person?",
    "deleteContactPersonErrorText": "Deleting the contact person has failed. Please try again.",
    "deleteContactPersonSuccessText": "The selected contact person has been deleted",
    "deleteContactPersonSuccessTitle": "Contact person has been deleted",
    "discount": {
      "deliveryDiscount": "Discount on delivery",
      "productDiscount": "Discount on products",
      "servicesDiscount": "Discount on decorations"
    },
    "edit": "Customer editing",
    "editAddress": "Edit address",
    "editAddressErrorText": "Address editing has failed. Please try again.",
    "editAddressSuccessText": "The specified address has been changed",
    "editAddressSuccessTitle": "Address has been changed",
    "editClientErrorText": "Customer editing has failed. Please try again.",
    "editClientSuccessText": "Customer details have been modified",
    "editClientSuccessTitle": "Customer has been modified",
    "editContactPerson": "Edit contact person",
    "editContactPersonErrorText": "Contact person edit failed. Please try again.",
    "editContactPersonSuccessText": "Contact person entered has been modified",
    "editContactPersonSuccessTitle": "Modify contact person",
    "editPasswordErrorText": "Password change has failed. Please try again.",
    "editPasswordSuccessText": "Password has been changed",
    "editPasswordSuccessTitle": "Password changed",
    "enterCustomerData": "Please enter customer details",
    "fountAddresses": "Addresses found:",
    "getDataFromGUS": "Get data from GUS",
    "getDataFromVIES": "Get data from VIES",
    "houseNumber": "Premises number",
    "invoiceAddressSet": "Data modified",
    "invoiceAddressSetDesc": "Invoice data has been set",
    "invoiceAndCorrespondenceAddressSet": "Data modified",
    "invoiceAndCorrespondenceAddressSetDesc": "Invoice and correspondence data has been set",
    "invoiceInfo": "Invoice details",
    "invoiceName": "Invoice name",
    "isOrdersInRpogress": "Orders pending?",
    "maxAddressSearchResults": "A maximum of 50 matching addresses are displayed, if you cannot find the address you need - narrow down your search criteria.",
    "newsletterAgreement": "Consent to newsletter",
    "noAddressesToDisplay": "No addresses to display",
    "noContactPeopleToDisplay": "No contact persons to display",
    "noCustomerMarchingPhraseFound": "No customers matching the specified phrase",
    "noCustomersToDisplay": "No customers to display",
    "noTranslationsForThisClient": "No translations available for this customer",
    "notFoundInVIESGUSText": "Given company not found in database",
    "notFoundInVIESGUSTitle": "Not found",
    "offersInProgress": "Offers pending",
    "ordersAndOffers": "Orders and offers",
    "ordersInProgress": "Orders pending",
    "passowrdChange": "Password change",
    "person": "Person",
    "phoneShortCap": "Phone",
    "profile": "Profile",
    "removeCustomerConfirmTitle": "Are you sure you want to delete this customer?",
    "removeCustomerErrorText": "Deleting the customer has failed. Please try again.",
    "removeCustomerSuccessText": "The selected customer has been deleted",
    "removeCustomerSuccessTitle": "Customer has been deleted",
    "removeLogo": "Delete logo",
    "searchAddressesByCompanyNameAddressOrContactInfo": "Search for addresses by company name, address or contact details",
    "selectCustomer": "Select customer",
    "shippingInfo": "Shipping details",
    "showCustomerDrafts": "Show offers",
    "showCustomerOrders": "Show orders",
    "statistics": "Statistics",
    "stockReportsNotifications": "Stock notifications",
    "street": "Street",
    "telephone": "Phone",
    "termsOfSale": "Terms of sale",
    "unsettledInvoices": "Outstanding invoices",
    "vatIDNumber": "NIP / VAT ID",
    "verificationIntegrationDisabledDesc": "Currently the service is unavailable",
    "verificationIntegrationDisabledTitle": "Service unavailble",
    "withOrdersInProgress": "With pending orders",
    "withoutOrdersInProgress": "Without pending orders",
    "youMustSelectCountryPrefix": "Lack of country code",
    "youMustSelectCountryPrefixDesc": "Before downloading data you must select country code",
    "yourAccount": "Your account",
    "zipCode": "Postcode"
  },
  "customerOrdersPopup": {
    "offers": "Customer offers",
    "orders": "Customer orders"
  },
  "dashboard": {
    "customersPopup": {
      "customerEmail": "E-mail",
      "customerName": "Customer name",
      "customerPhone": "Phone",
      "title": "Send customer enquiries"
    }
  },
  "errorPage": {
    "errorCode": "404",
    "pageDoesNotExist": "The selected subpage does not exist",
    "tryAgainLaterOrContactAdministrator": "Try again later or contact your system administrator."
  },
  "inquiries": {
    "addComments": "Add your comments",
    "addFirstProductInstructionInfo": "Add your first product by clicking “+ Product”",
    "addFirstServiceInstructionInfo": "Add your first general decoration by clicking “+ General decoration”",
    "caanotCreateOrder": "Unable to create order",
    "executionTime": "Lead time",
    "failedToAddProductsToOrder": "You have not added products to your order",
    "globalServicesTooltip": "If multiple products have the same decoration, add a general decoration from here. We will then only count the setup cost once. You will be able to distribute the number of decorations ordered to individual products.",
    "needExecutionTill": "I need delivery by",
    "noComments": "No comments",
    "noDateSelected": "No deadline",
    "orderAdditionalInfo": "Additional notes to the order",
    "selectExecutionTime": "Select lead time",
    "trackingNumber": "Tracking number",
    "unexpectedErrorOccured": "An unexpected problem has occurred"
  },
  "login": {
    "authError": "Authorisation error. Please try again",
    "emailPlaceholder": "Your e-mail address",
    "loginInProgress": "Login...",
    "loginLabel": "Log in",
    "password": "Password",
    "passwordPlaceholder": "********",
    "register": "Do not have account?",
    "resetPassword": "Forgot password?"
  },
  "noPermissions": {
    "noPermissionsDescription": "If you think this is an error - please contact your system administrator.",
    "noPermissionsText": "You are not authorised to view this page",
    "noPermissionsTitle": "No authorisation granted"
  },
  "order": {
    "addNewDraft": "Add new offer",
    "addNewFemenine": "Add new",
    "addNewOrder": "Add new order",
    "addNewShippingAddress": "Add new shipping address",
    "addedProducts": "The following products have been added:",
    "addressRemoved": "The previously used address has been deleted. Please select a new address.",
    "awaitingInvoice": "waiting for invoice",
    "awaitingProductionComplete": "awaiting completion of production",
    "awaitingSample": "awaiting sample",
    "awaitingSampleAcceptance": "awaiting sample approval",
    "beeingCollected": "In the process of collection",
    "blockade": "Blockade",
    "cartonsMissingInfo": "The number of cartons may need to be adjusted as some products do not have a specific number of pieces in cartons.",
    "cartonsNumber": "Number of cartons",
    "checkFormDesc": "Errors that need to be corrected were found during the validation process. Please check the form tabs and correct the errors found.",
    "checkFormTitle": "Please check the form",
    "chooseShippingAddress": "Select shipping address",
    "clientContactPerson": "Customer contact person",
    "connectedInvoices": "Related invoices",
    "currentDiscountOfCustomer": "Current discount in customer profile is",
    "customerAndName": "Customer and name",
    "customerDiscounts": "Customer discounts",
    "dashOrderAwaitingShipping": "- orders awaiting shipment",
    "dashReadyForShipping": "- ready to ship",
    "dateOfIssue": "Date of issue",
    "deleted": "Deleted",
    "delivery": "Delivery",
    "download": "Download",
    "downloadPDF": "Download PDF",
    "downloadPDFforMe": "PDF for my COMPANY",
    "downloadPDFforMyCustomer": "PDF for my CUSTOMER",
    "downloadXls": "Download XLS",
    "draftDeleteConfirmTitle": "Are you sure you want to delete this offer?",
    "draftDeleteErrorText": "Offer deletion failed. Please try again.",
    "draftDeleteSuccessText": "The selected offer has been deleted",
    "draftDeleteSuccessTitle": "Offer deleted",
    "draftsList": "List of offers",
    "duplicateOrder": {
      "questionTextOffer": "Are you sure you want to duplicate the selected offer?",
      "questionTextOrder": "Are you sure you want to duplicate the selected order?",
      "questionTitle": "Confirm operation",
      "successTextOffer": "The selected offer has been duplicated successfully",
      "successTextOrder": "The selected order has been duplicated successfully",
      "successTitleOffer": "You have duplicated an offer",
      "successTitleOrder": "You have duplicated an order"
    },
    "editDraft": "Edit offer",
    "editDraftErrorText": "Unable to save offer",
    "editDraftSaveSuccessText": "The offer has been saved successfully",
    "editDraftSuccessTitle": "The offer has been saved",
    "editingOfferFromHPL1": "You are editing offer created for <strong>your COMPANY</strong>. If you want to convert it into <strong>offer for your CUSTOMER</strong>, please click ",
    "editingOfferFromHPL2": "here",
    "editingOfferFromHPL3": "Please remember to save offer after this change.",
    "ended": "Completed",
    "errors": {
      "shipping_price_not_fetched": "The delivery price could not be updated. Please verify the delivery price."
    },
    "fileSuffixOfferCustomer": "-OFFER-CUSTOMER",
    "fileSuffixOfferMe": "-OFFER-HPL",
    "files": {
      "addingFile": "Deleting the file",
      "deleteFile": "Delete file",
      "editFile": "Edit file",
      "editFileText": "Provide updated file description",
      "editFileTitle": "File description change",
      "fileEditError": "An error has occurred while editing the file. Please try again.",
      "noFilesToDisplay": "No files linked to this order",
      "noServiceFilesToDisplay": "No files linked to this decoration",
      "removeFileDesc": "This operation cannot be undone",
      "removeFileTitle": "Are you sure you want to delete this file?",
      "title": "Files assigned to the order",
      "uploadError": "An error has occurred while adding a file"
    },
    "forAcceptance": "To be accepted",
    "inProduction": "In production",
    "includedCustomerDiscount": "Customer discount",
    "includedMarkup": "Markup",
    "invoicesIssued": "Invoices issued",
    "lastChange": "last change",
    "lastItemModified": "Last changed",
    "lastItemViewed": "Last viewed",
    "nameCheck": {
      "inProgress": "Checking the order name",
      "inUse": "The selected order name is already in use by other orders.",
      "isAvailable": "The selected order name is available"
    },
    "noAddressFound": "No address selected",
    "noAddresses": "No addresses",
    "noAddressesForThisClient": "No addresses assigned to the customer.",
    "noContactPeople": "No contact persons",
    "noInvoicesConnectedToOrder": "No invoices linked to this order",
    "nonExistingCustomerText": "The customer assigned to this order has been deleted. Please assign a customer to the order again.",
    "nonExistingCustomerTitle": "The selected customer does not exist",
    "noOffersOrOrdersToDisplay": "No offers or orders to display",
    "noOrderMatchingPhraseFound": "No orders matching the specified phrase",
    "noTagsMatchingGivenPhrase": "No features matching the specified phrase",
    "number": "Number",
    "numberOfOrderdProducts": "Number of products ordered",
    "offerCurrency": "Currency of offer",
    "offerLanguage": "Language of offer",
    "offerPreparedFor": "Oferta przygotowana dla",
    "offerSubmissionDate": "Date of offer submission",
    "offersToCheck": "Offers to be checked",
    "orderNumber": "Order number",
    "orderPreparedFor": "Zamówienie przygotowane dla",
    "orderPreview": "Order preview",
    "orders": "Orders",
    "ordersList": "Order list",
    "ordersXlsFilename": "order-list",
    "paymentDate": "Payment date",
    "paymentDeadline": "Payment due date",
    "pdfDownloadNoticeDesc": "You download PDF offer for yourself. Please do not provide this file to your customer.",
    "pdfDownloadNoticeTitle": "Attention!",
    "pendingPayment": "Awaiting payment",
    "priceChangePopup": {
      "changeSource": "Source of change",
      "element": "Item",
      "new": "New value",
      "previous": "Previous value",
      "sources": {
        "prices": "HPL price list",
        "customer_prices": "Your price list"
      },
      "subtitle": "These changes will be applied after saving offer again",
      "title": "The following price changes have been made",
      "type": "Type of change",
      "types": {
        "globalServiceMultipleFrom": "Global decoration multiplier",
        "globalServicePrice": "Price of global decoration",
        "globalServiceSetupPrice": "Set-up price of global decoration",
        "product": "Product",
        "serviceMultipleFrom": "Decoration multiplier",
        "servicePrice": "Price of decoration",
        "serviceSetupPrice": "Set-up price of decoration"
      }
    },
    "productMinQty": "Min. quantity",
    "productsTags": "Product features",
    "readyForShipping": "Ready to ship",
    "saveAsOrder": "Submit order for processing",
    "saveAsOrderNoticeDesc": "Once saved as an order, the data cannot be edited - please make sure that all data you have entered are correct.",
    "saveAsOrderNoticeTitle": "Send order for processing",
    "saveDraft": "Save offer",
    "see": "View",
    "selectOrder": "Select your order",
    "sent": "Sent",
    "servicesGenitive": "Decorations",
    "shippingAddress": "Shipping address",
    "showAddress": "Show address",
    "showContact": "Show contact",
    "summary": "Summary",
    "toCheckInWarehouse": "To be checked in the warehouse",
    "toCollect": "To be collected",
    "toDelete": "To be removed",
    "totalCost": "Total cost",
    "totalDeliveryCostNet": "Delivery cost (net)",
    "useCustomerDiscounts": "Use customer discounts",
    "usePartnerPricing": "Use your own pricing in this order",
    "valueForPartnerCustomer": "Customer order value",
    "waitingForShipping": "Waiting for shipment",
    "waitingPurchaseProducts": "Awaiting products",
    "whoOrders": "Orderer",
    "whoOrdersMe": "My COMPANY",
    "whoOrdersMyCustomer": "My CUSTOMER",
    "withDeadlineApproaching": "with a deadline approaching",
    "yesSave": "Yes, save",
    "yourDiscounts": "Your discounts",
    "yourPrice": "Your price"
  },
  "price": {
    "addNewPrice": "Add a new price",
    "addNewProductPrice": "Add a new product price",
    "addNewServicePrice": "Add a new service price",
    "addNewSetupPrice": "Add a new setup price",
    "addPrice": "Add price",
    "addPriceErrorText": "Adding a price has failed. Please try again.",
    "addPriceSuccessText": "The price has been saved",
    "addPriceSuccessTitle": "Price added",
    "bruttonPrice": "Gross price",
    "chosenPriceIsSetupPrice": "The given price is the price per setup",
    "deletePriceConfirmTitle": "Are you sure you want to delete this price?",
    "deletePriceErrorText": "Price removal failed. Please try again.",
    "deletePriceSuccessText": "The selected price has been deleted",
    "deletePriceSuccessTitle": "Price deleted",
    "differentPriceMultipleFromInfo": "The applied price multiplier \"per unit from\" is different from the current price multiplier ({value} pcs.)",
    "editPrice": "Edit the price",
    "export": "Export",
    "exportPrices": "Export price lists",
    "exportSuccessfull": "Price lists exported",
    "exportSuccessfullDesc": "Price lists exported successfully",
    "importPrices": "Import price lists",
    "importSuccessfull": "Price lists imported",
    "importSuccessfullDesc": "Price lists imported successfully",
    "includeSetupPrices": "Include setup prices",
    "isSale": "Sale",
    "noPricesFoundForServiceGroup": "Price lists for the selected group of services were not found",
    "noPricesToDisplay": "No prices to display",
    "onlyPriceUpdate": "Price update only",
    "pln": "PLN",
    "plnBrutto": "PLN gross",
    "plnNet": "PLN net",
    "plnVat": "PLN VAT",
    "price": "Price",
    "priceFlat": "Flat price",
    "priceBox": "Quantity-based price",
    "price25pcs": "to 25 pcs.",
    "priceFirstBox": "First box",
    "priceSecondBox": "Second box",
    "priceNextBox": "Next box",
    "priceBeforeDicount": "Price before discount",
    "priceEdit": "Price edit",
    "priceFrom": "Price from",
    "priceImportFrom": "Prices imported from",
    "priceNet": "Net price",
    "pricePerItem": "Price per item",
    "pricePerItemFrom": "Price per piece from {price} pcs.",
    "pricePerItemShort": "Price per item",
    "prices": "Prices",
    "priceTo": "Price up to",
    "pricesLists": "Price lists",
    "pricesListsLowCase": "price list",
    "productGenitive": "product",
    "productsPricesList": "List of product prices",
    "quantityFrom": "Quantity from",
    "quantityTo": "Quantity to",
    "removeAndReplacePrices": "Delete prices and add again",
    "savePriceErrorText": "Price edit failed. Try again.",
    "savePriceSuccessText": "The selected price has been changed",
    "savePriceSuccessTitle": "Price changed",
    "seePricelist": "View price list",
    "serviceGenitive": "services",
    "servicesPriceList": "List of services prices",
    "servicesPricesList": "List of prices of services",
    "setup": "setup",
    "setupPricesList": "List of setup prices",
    "supplierPricesFileNamePrefix": "prices-suppliers-",
    "unitPricesIn": "prices per unit in",
    "vat": "VAT",
    "vatRate": "VAT rate",
    "xlsxFileWithPrices": "XLSX file with prices"
  },
  "product": {
    "addGlobalService": "General decoration",
    "addGlobalServicesPackage": "Decorations package",
    "addProduct": "Product",
    "breakProductsIntoSeparateOffers": "Break down products into separate offers",
    "checkAvailability": "Check upcoming deliveries",
    "enterAdditionalProductDescriptionOptional": "Enter additional product description (optional)",
    "enterProductNameOrCode": "Enter product name or code",
    "globalServices": "General decorations",
    "noProductsMatchingGivenPhrase": "No products matching the specified phrase",
    "notIncludedInDiscounts": "Not subject to discounts",
    "product": "Product",
    "productCode": "Product code",
    "productName": "Product name",
    "products": "Products",
    "productsCodes": "Product codes",
    "selectProduct": "Select product",
    "totalBeforeDiscount": "Before discount",
    "totalMarkup": "Including markup",
    "totalProductsCostNet": "Cost of products (net)",
    "totalServicesCostNet": "Cost of decorations (net)",
    "useCustomPartnerPrice": "Use your own price",
    "useDefaultPartnerPrice": "Use default price"
  },
  "purchase": {
    "addOrderErrorText": "Adding an order has failed. Please try again.",
    "editOrderSuccessTitle": "Order has been saved",
    "fileDeletedDesc": "The selected file has been deleted",
    "fileDeletedTitle": "File has been deleted",
    "numberOfPiecesNeeded": "Number of items needed",
    "removeFileInProgress": "Deleting the file",
    "yourOrderSaveSuccessText": "Your order has been saved"
  },
  "register": {
    "customerTaxNumber": "NIP/VAT ID",
    "login": "Log in",
    "password": "Password",
    "passwordConfirmation": "Repeat password",
    "passwordReset": {
      "error": "Password change failed",
      "resetLabel": "Change password",
      "resetInProgress": "Saving changes",
      "success": "Password changed – you can now log in",
      "title": "Change password"
    },
    "passwordResetRequest": {
      "error": "Password reset failed",
      "resetInProgress": "Resetting password",
      "resetLabel": "Request password reset",
      "success": "Password reset request has been sent. If the given e-mail exists in our system, you will get further instructions to your e-mail.",
      "title": "Reset password"
    },
    "registerError": "Registration failed",
    "registerInProgress": "Registering",
    "registerLabel": "Register",
    "registerSuccess": "Account created. Pending verification and approval.",
    "title": "Create an account"
  },
  "service": {
    "addService": "Decoration",
    "addServicesPackage": "Decorations package",
    "addServicesPackageBtn": "Add a decoration package",
    "chooseEmbroideryPosition": "Select position of decoration",
    "chooseEmbroideryType": "Please select the type of decoration",
    "chooseService": "Please select your decoration",
    "chooseServiceGroup": "Select service group",
    "commonServices": "Common decorations",
    "complexity": "Complexity level",
    "descriptionFoCustomer": "Description for customer",
    "detailsOfServiceInOrder": "Decoration details in your order",
    "downloadLogo": "Download logo",
    "dstNumber": "DST number",
    "embroidery": {
      "colors": "Decoration colours",
      "height": "HEIGHT",
      "position": "Position of decoration",
      "size": "Decoration size (mm)",
      "type": "Type of decoration",
      "width": "WIDTH"
    },
    "enterServiceNameOrCode": "Enter the name or code of the decoration",
    "files": {
      "title": "Decoration files"
    },
    "findService": "Find matching service",
    "noServiceGroupsMatchingPhrase": "No services groups matching the given phrase",
    "noServicesMatchingPhrase": "No decoration matching the given phrase",
    "productionCompleteDate": "Date of production completion",
    "sample": {
      "sampleAcceptDate": "Date of sample acceptance",
      "sampleDate": "Sample date",
      "samplePhotosDateCreated": "Date added",
      "samplePhotosDownload": "Download",
      "samplePhotosDownloadAll": "Download all",
      "samplePhotosSeePreview": "View image of sample",
      "samplePhotosTitle": "Photos of samples",
      "sampleReceiveDate": "Date of sample receipt"
    },
    "sampleFiles": {
      "title": "Sample files"
    },
    "samples": {
      "noSamples": "No samples",
      "rejectReason": "Reason for rejection",
      "sample": "Sample",
      "saveBeforeAddingFiles": "Save order to be able to add files",
      "statuses": {
        "accepted": "Accepted",
        "rejected": "Rejected"
      },
      "title": "Decoration samples"
    },
    "selectFileWithLogo": "Select file with logo",
    "selectService": "Please select your decoration",
    "selectedServiceName": "Selected service",
    "service": "Decoration",
    "serviceCode": "Service code",
    "serviceGroup": "Decoration group",
    "serviceName": "Decoration name",
    "serviceNotFound": "Service not found",
    "serviceNotFoundDesc": "For given service group, complexity and given dimensions there are no matching service. Please try different configuration of service.",
    "servicesPackage": {
      "dates": {
        "date": "Date",
        "types": {
          "obtaining_at": "Date of receipt of sample",
          "accepted_at": "Date of sample acceptance",
          "sample_hpl_accepted_at": "Sample acceptance date"
        }
      }
    },
    "servicesPackageHideContents": "Hide content",
    "servicesPackageInvalidConfig": {
      "noMatchingService": "There is no matching decoration for the given configuration",
      "wrongDimensions": "Incorrect dimensions of the decoration were given"
    },
    "servicesPackageModify": "Modify the size and complexity of the decoration",
    "servicesPackageVariant": "Selected variant",
    "servicesPackageName": "Name of the decoration package",
    "servicesPackagePopup": {
      "addServicesPackage": "Add a decoration package",
      "includedServices": "Decorations included in the selected decoration package:",
      "noServicesIncluded": "There are no decorations assigned to the selected decoration package.",
      "noServicesPackagesMatchingGivenPhrase": "There are no packages matching the given phrase.",
      "selectServicesPackage": "Choose a decoration package",
      "title": "Select the decoration package to add"
    },
    "servicesPackageShowContents": "Show content",
    "setupPrice": "Setup cost",
    "stitchNumber": "Number of stitches",
    "strandColors": "Thread colours",
    "wrongDimensions": "Invalid service dimensions",
    "wrongDimensionsDesc": "Please provide width and height of the service"
  },
  "settings": {
    "country": {
      "country": "Country",
      "countryCode": "Country code",
      "selectCountry": "Select country"
    },
    "currency": {
      "chooseCurrency": "Select currency",
      "currency": "Currency",
      "noCurrenciesAvailable": "No currencies available..."
    },
    "language": {
      "chooseLanguage": "Select language",
      "noLanguagesAvailable": "No languages available"
    },
    "transaltion": {
      "addTranslation": "Add translation",
      "addTranslationErrorText": "Adding the translation has failed. Please try again.",
      "addTranslationSuccessText": "The specified translation has been saved",
      "addTranslationSuccessTitle": "Translation added",
      "deleteTranslationConfirmTitle": "Are you sure you want to delete this translation?",
      "deleteTranslationErrorText": "Deleting the translation has failed. Please try again.",
      "deleteTranslationSuccessText": "The selected translation has been deleted",
      "deleteTranslationSuccessTitle": "Translation deleted",
      "editTranslation": "Edit translation",
      "translationEditErrorText": "Translation editing has failed. Please try again.",
      "translationEditSuccessText": "The selected translation has been changed",
      "translationEditSuccessTitle": "Translation modified",
      "translations": "Translations"
    }
  },
  "settlements": {
    "amount": "Amount",
    "deadlines": "Deadlines",
    "invoiceList": "List of invoices",
    "issued": "Issued",
    "noSettlementsToDisplay": "No settlements to display",
    "paymentDueDate": "Payment until",
    "settle": "Settle",
    "settled": "Settled",
    "settlement": "Settlement",
    "settlements": "Settlements",
    "type": "Type"
  },
  "shippers": {
    "chooseShipper": "Select freight forwarder",
    "noShippersAvailable": "No freight forwarders available"
  },
  "status": {
    "status": "Status",
    "statusQuestionMark": "Status?"
  },
  "translation": {
    "editTranslation": "Edit translation",
    "languageLocative": "language",
    "languagesLocative": "languages",
    "missingTranslationsIn": "Missing translation in ",
    "noTranslationsToDisplay": "No translations available...",
    "systemName": "System name",
    "translated": "Translated",
    "translationEditErrorText": "An error occurred while saving changes. Please try again...",
    "translationEditSuccessText": "Translation changes have been saved",
    "translationEditSuccessTitle": "Changes saved",
    "translationStatus": "Translation status",
    "translations": "Translations",
    "translationsTitle": "Translation list",
    "valueInPolish": "In Polish"
  },
  "ui": {
    "actionFailedTryAgain": "Operation has failed. Please try again.",
    "actions": "Actions",
    "add": "Add",
    "addDescription": "Add description",
    "addNew": "Add new",
    "addToCart": "To cart",
    "address": "Address",
    "allFieldsAreRequired": "All fields are required",
    "amount": "Quantity",
    "availability": "Availability",
    "back": "Back",
    "backToList": "Back to the list",
    "cancel": "Cancel",
    "cart": "Cart",
    "cartIsEmpty": "The cart is empty",
    "chooseDate": "Select date",
    "close": "Close",
    "companyName": "Company name",
    "contactPerson": "Contact person",
    "createOrderFromCart": "Create order from products",
    "dataLoading": "Loading data in progress",
    "dataLoadingFailed": "Loading data has failed.",
    "daysOfWeek": {
      "fri": "Fri",
      "mon": "Mon",
      "sat": "Sat",
      "sun": "Sun",
      "thur": "Thurs",
      "tue": "Tue",
      "wed": "Wed"
    },
    "deadlinePreferred": "Preferred date",
    "delete": "Delete",
    "deleteConfirmText": "This operation cannot be undone",
    "downloadInProgress": "Download in progress",
    "duplicate": "Duplicate",
    "eMailCap": "E-mail",
    "eMailShort": "e-mail",
    "edit": "Edit",
    "emailAddress": "E-mail address",
    "errorOccured": "Error has occurred",
    "errorOccuredDuringDownload": "Download error has occurred",
    "filtersSearch": "Search",
    "generalInfo": "General data",
    "importErrorTitle": "An error has occurred during import",
    "importFile": "Import file",
    "importType": "Type of import",
    "inCart": "In the cart",
    "invoiceNumber": "Invoice number",
    "isSettled": "Settled?",
    "lack": "None",
    "language": "Language",
    "leadingPerson": "Order processor",
    "loadError": "LOADING ERROR HAS OCCURRED",
    "markupProducts": "Markup on products",
    "markupServices": "Markup on decorations",
    "markupSetupServices": "Markup on services setup",
    "markupShipping": "Markup on shipping",
    "monthNames": {
      "apr": "Apr",
      "aug": "Aug",
      "dec": "Dec",
      "feb": "Feb",
      "jan": "Jan",
      "jul": "Jul",
      "jun": "Jun",
      "mar": "Mar",
      "may": "May",
      "nov": "Nov",
      "oct": "Oct",
      "sep": "Sep"
    },
    "myOrders": "My orders",
    "name": "Name",
    "nameAndSurename": "Name and surname",
    "no": "No",
    "noAvailabilityData": "No availability data",
    "notSettled": "Unsettled",
    "ok": "OK",
    "okUnderstand": "OK, I understand",
    "order": "Order",
    "orderName": "Order name",
    "pagination": {
      "itemsAmount": "Number of items:"
    },
    "partnerDiscountProducts": "Customer products discount",
    "partnerDiscountServices": "Customer services discount",
    "partnerDiscountShipping": "Customer shipping discount",
    "phoneShort": "phone:",
    "pieces": "Pieces",
    "piecesAbbr": "pcs.",
    "piecesAmount": "Number of pieces",
    "productsGenitive": "Products",
    "refNumber": "Reference number",
    "refreshPage": "Refresh webpage",
    "repeatPassword": "Repeat password",
    "resetFilters": "Reset filters",
    "saveChanges": "Save changes",
    "search": "Search",
    "searchFrom": " search from",
    "searchTo": " to",
    "searching": "Search in progress",
    "selectContactPerson": "Select contact person",
    "selectFile": "Select file",
    "selectLeadingPerson": "Select order processor",
    "selectedPersonNotFound": "No person selected",
    "settled": "Settled",
    "shipper": "Shipper",
    "supplier": "Supplier",
    "toTryAgain": "to try again",
    "tryAgain": "Please try again",
    "value": "Value",
    "viewInNewTab": "See in a new tab",
    "yes": "Yes",
    "yesRemove": "Yes, delete"
  },
  "users": {
    "accountActive": "Active account",
    "accountInactive": "Inactive account",
    "active": "Active",
    "addUser": "Add user",
    "addUserErrorText": "Adding a user has failed. Please try again.",
    "addUserSuccessText": "The specified user has been saved",
    "addUserSuccessTitle": "User added",
    "addingNewUser": "Adding a new customer",
    "customer": "Customer",
    "deleteConfirmTitle": "Are you sure you want to delete this user?",
    "deleteErrorText": "Deleting the user has failed. Please try again.",
    "deleteSuccessText": "The selected user has been deleted",
    "deleteSuccessTitle": "User deleted",
    "editUser": "User editing",
    "editUserErrorText": "User editing has failed. Please try again.",
    "editUserSuccessText": "The selected user has been changed",
    "editUserSuccessTitle": "User modified",
    "inactive": "Inactive",
    "isAccountActive": "Active account?",
    "loggedInAs": "Logged in as",
    "noUsersMatchingPhrase": "No employees matching the given phrase",
    "noUsersToDisplay": "No users to display",
    "selectWorker": "Select employee",
    "usersLabel": "Users",
    "usersList": "List of users",
    "usersSearchPlaceholder": "Enter the user's first name, surname or e-mail"
  },
  "validation": {
    "fieldCanContainAtLeast1Char": "This field must contain at least one character",
    "fieldCanContainAtLeast24Chars": "This field must contain at least {min} characters",
    "fieldCanContainAtLeastNChars": "This field must contain at least {min} characters",
    "fieldCanContainAtMax1Char": "This field can contain a maximum of one character",
    "fieldCanContainAtMax24Chars": "This field can contain a maximum of {max} characters",
    "fieldCanContainAtMaxNChars": "This field can contain a maximum of {max} characters",
    "onlyBigLetters": "This field can only contain upper case letters",
    "onlyLettersAndDashes": "This field can only contain letters and hyphens",
    "onlyLettersAndNumbers": "This field can only contain letters and digits",
    "onlyNumbers": "This field must contain a number",
    "onlyIntegerNumbers": "This field must contain integer number",
    "passwordsAreNotIdentical": "Passwords are not identical",
    "required": "This field is required",
    "validDoubleNumericRequired": "The required number is 123.45",
    "validEmailRequired": "This field must contain a valid email address",
    "validUrlRequired": "This field must contain a valid URL",
    "valueCannotBeGreaterThan": "The value must not be greater than",
    "valueCannotBeLessThan": "The value must not be less than",
    "valueMustContainOrderID": "The order name must contain the order ID:",
    "youMustSelectValue": "You must select a value"
  },
  "welcome": {
    "baseballCaps": "Baseball caps",
    "capVizors": "Cap vizor",
    "choose": "Select",
    "clear": "Clear",
    "clientPanel": "Customer panel",
    "companyName": "Headwear",
    "filter": "Filter",
    "filterAvailability": "Availability filter",
    "filterByNameOrCode": "Filter by name/code",
    "filterByPrice": "Filter by price",
    "hats": "Hats",
    "noProductsInSearchCriteria": "No products meeting your criteria",
    "orderInfo": "Complete your orders <span class=\"text-primary font-weight-bold\">in 5 easy steps</span>:",
    "productBrowserInfo": "Use our <span class=\"font-weight-bold\">product finder</span>. You will find product images, price and stock status. You can also start creating your order from the product finder. Simply click next to the product <span class=\"font-weight-bold\">\"To cart\"</span>. You can then add the entire cart to your order.",
    "requireAll": "Request all",
    "searchProducts": "Search for product",
    "setp": "Step",
    "stepFiveContent": "Click <span class=\"font-weight-bold\">\"Save offer\"</span> or <span class=\"font-weight-bold\">\"Submit order for processing\" button.",
    "stepFourContent": "Under the <span class=\"font-weight-bold\">\"General data\" tab </span> fill in the delivery and contact details",
    "stepOneContent": "Go to the <span class=\"font-weight-bold\">\"Orders\" tab</span>.",
    "stepThreeContent": "Under the <span class=\"font-weight-bold\">\"Order\" tab</span> select the products and decorations",
    "stepTwoContent": "Click the <span class=\"font-weight-bold\">\"Add” button</span>.",
    "wantToCheckOurProducts": "Want to quickly check our products and prices?",
    "welcomeToClientPanel": "Welcome to the HeadWear customer panel",
    "winterHats": "Beanies"
  }
};
